import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { isToday } from 'date-fns';
import { Check } from 'lucide-react';
import { shortDate, shortDay } from '@utils/i18n';
import { cn } from '@utils/cn';
import { jobDayTabStyle } from '../constants';
import { getTopCommitment } from '../../helpers';
import { JobDayTabProps } from './types';

export const JobDayTab = forwardRef<HTMLButtonElement, JobDayTabProps>(
  ({ data, active, onClick }, ref) => {
    const { t } = useTranslation('app', { keyPrefix: 'pages.job.days' });
    const commitment = getTopCommitment(data.tasks);

    return (
      <button
        ref={ref}
        type="button"
        onClick={onClick}
        aria-pressed={active}
        className={cn(
          jobDayTabStyle.base,
          active ? jobDayTabStyle.active : jobDayTabStyle.idle,
          commitment === 'draft' && 'border-dashed border-neutral-300',
        )}>
        {(commitment === 'rejected' || commitment === 'waiting') && (
          <span
            className={cn(
              'h-2 w-2 shrink-0 rounded-full',
              commitment === 'rejected' ? 'bg-danger-500' : 'bg-warning-500',
            )}
          />
        )}
        {data.status === 'completed' && <Check className="h-3.5 w-3.5 shrink-0 text-primary-500" />}
        {[shortDay(data.day), shortDate(data.day)].join(', ')}
        {commitment === 'draft' && (
          <span className="text-[9px] font-bold uppercase tracking-wide text-neutral-400">
            {t('draftTab')}
          </span>
        )}
        {isToday(data.day) && (
          <span className="text-[9px] font-bold uppercase tracking-wide text-blue-500">
            {t('today')}
          </span>
        )}
      </button>
    );
  },
);

// eslint-disable-next-line immutable/no-mutation
JobDayTab.displayName = 'JobDayTab';
